export default function Reputation() {
  const reviews = [
    {
      name: "小王",
      role: "资深吃瓜用户",
      content: "自从用了51吃瓜，每天第一时间就能看到最新的八卦内容。分类清晰，视频画质也很棒，推荐给所有吃瓜爱好者！",
      rating: 5,
    },
    {
      name: "Lisa",
      role: "娱乐博主",
      content: "作为娱乐行业的从业者，51吃瓜是我获取行业动态和热门话题的重要渠道。内容更新快，覆盖面广。",
      rating: 5,
    },
    {
      name: "阿强",
      role: "忠实用户",
      content: "最喜欢每日大赛和台北娜娜这两个栏目，更新频率高，内容质量也好。已经成为我每天的必刷网站了。",
      rating: 5,
    },
    {
      name: "小美",
      role: "八卦爱好者",
      content: "51吃瓜的内容分类做得很好，想找什么类型的八卦都能快速找到。黑料吃瓜栏目尤其精彩！",
      rating: 4,
    },
    {
      name: "大明",
      role: "视频剪辑师",
      content: "从专业角度看，51吃瓜的视频画质和剪辑水平都很高。莫里秀栏目的一些作品甚至达到了电影级别的制作水准。",
      rating: 5,
    },
    {
      name: "小芳",
      role: "吃瓜达人",
      content: "网站整体体验流畅，界面设计美观。玩偶姐姐的资源在这里更新最快，比别的平台都及时。",
      rating: 5,
    },
  ];

  return (
    <section className="py-8 md:py-10">
      <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-5">
        用户口碑
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {reviews.map((review) => (
          <div
            key={review.name}
            className="p-5 bg-background-50 rounded-lg border border-background-200/60"
          >
            <div className="flex items-center gap-1 mb-2">
              {Array.from({ length: 5 }).map((_, i) => (
                <i
                  key={i}
                  className={`ri-star-fill text-sm ${
                    i < review.rating
                      ? "text-amber-500"
                      : "text-background-300"
                  }`}
                ></i>
              ))}
            </div>
            <p className="text-sm text-foreground-700 leading-relaxed mb-3">
              &ldquo;{review.content}&rdquo;
            </p>
            <div>
              <span className="text-sm font-semibold text-foreground-900">
                {review.name}
              </span>
              <span className="text-xs text-foreground-500 ml-2">
                {review.role}
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}